var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"title":_vm.$t('SUPPORT.CONTACT_US')}},[_c('Card',[_c('p',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.$t('SUPPORT.SUPPORT_INFO')),expression:"$t('SUPPORT.SUPPORT_INFO')"}]})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }